import { chowlyApi } from 'config'
import { generatePath } from 'react-router-dom'
import client from '../chowly'
import { calculateDurationInSeconds } from '../util'
import {
  TypeName,
  PartnerSyncLifecycleSummaryAttributes,
  PartnerSyncLifecycleStatusesResponse,
  PartnerSyncLifecycleSummaryResource,
} from '../models'

export type PartnerSyncLifecycleSummaryWithDuration = PartnerSyncLifecycleSummaryAttributes & {
  duration: number
}

// GET /api/v3/partners/:partner_id/sync_lifecycles?include=sync_lifecycle_statuses
export const fetchPartnerSyncLifecycles = async (
  partnerId: number
): Promise<PartnerSyncLifecycleSummaryWithDuration[]> => {
  
  const path = generatePath(chowlyApi.partnerSyncLifecycleStatuses, { id: partnerId })
  const url = `${path}?include=sync_lifecycle_statuses`
  const response = await client.get<PartnerSyncLifecycleStatusesResponse>(url)

  const included = response.data.included ?? []

  const records: PartnerSyncLifecycleSummaryWithDuration[] = (
    included as PartnerSyncLifecycleSummaryResource[]
  )
    .filter((item) => item.type === TypeName.SyncLifecycleStatus)
    .map((item) => {
      const { start_timestamp, ending_timestamp, aasm_state } = item.attributes

      return {
        id: item.id,
        start_timestamp,
        ending_timestamp,
        aasm_state,
        duration: calculateDurationInSeconds(start_timestamp, ending_timestamp) ?? 0,
      }
    })

  return records.slice(0, 30)
}